import { Module } from 'vuex';
import PartnerInterface from '@/interfaces/PartnerInterface';

const partnerModule: Module<any, any> = {
  namespaced: true,

  state: {
    id: null as string | null,
    title: null as string | null,
    thumbnail: null as string | null,
    validated: null as boolean | null,
  },

  mutations: {
    SET_ID(state, id: string) {
      state.id = id;
    },
    SET_TITLE(state, title: string) {
      state.title = title;
    },
    SET_THUMBNAIL(state, thumbnail: string) {
      state.thumbnail = thumbnail;
    },
    SET_URL(state, url: string) {
      state.url = url;
    },
    SET_VALIDATED(state, validated: boolean) {
      state.validated = validated;
    },
    CLEAR(state) {
      state.title = null;
      state.thumbnail = null;
      state.url = null;
    },
  },

  actions: {
    switch({ commit }, partner: PartnerInterface | null) {
      const id = `${partner?.id || ''}`.trim();
      const title = `${partner?.title || ''}`.trim();
      const thumbnail = `${partner?.thumbnail || ''}`.trim();
      const isValid = title !== '' && thumbnail !== '';

      if (isValid) {
        commit('SET_ID', id);
        commit('SET_TITLE', title);
        commit('SET_THUMBNAIL', thumbnail);
        commit('SET_URL', partner?.url);
        commit('SET_VALIDATED', !!partner?.validated);
      } else {
        commit('CLEAR');
      }
    },
  },

  getters: {
    current(state): PartnerInterface | null {
      return state.id && state.title && state.thumbnail ? {
        id: state.id,
        title: state.title,
        thumbnail: state.thumbnail,
        url: state.url,
        validated: state.validated,
      } : null;
    },
    active(state, getters) {
      return getters.current !== null;
    },
    id(state): string | null {
      return state.id;
    },
    title(state): string | null {
      return state.title;
    },
    thumbnail(state): string | null {
      return state.thumbnail;
    },
    url(state): string | null {
      return state.url;
    },
  },
};

export default partnerModule;
